<template>
  <div :class="`text-${field.textAlign}`">
    <Dropdown>
      <Button variant="link">
        {{ __('Show :count items', { count: items.length }) }}
      </Button>

      <template #menu>
        <DropdownMenu width="auto">
          <ul v-if="items.length > 0" class="max-w-xxs space-y-4 py-3 px-4">
            <li
              v-for="(item, index) in items" :key="item[valueKey]"
              class="flex items-center rounded-full font-bold text-sm leading-tight space-x-2"
            >
              <span class="ml-1">{{ item[labelKey] }}</span>
            </li>
          </ul>
          <span v-else>{{ __('No items') }}</span>
        </DropdownMenu>
      </template>
    </Dropdown>
  </div>
</template>

<script>
import { Button } from 'laravel-nova-ui'

export default {
  components: {
    Button,
  },

  props: ['resourceName', 'field'],

  data: () => ({
    items: [],
  }),

  created() {
    this.items = this.field.value;
  },

  computed: {
    labelKey() {
      return this.field.labelKey ?? 'full_name';
    },
    valueKey() {
      return this.field.valueKey ?? 'id';
    }
  },

}
</script>
